import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { BatchService } from 'src/app/private/services/batch.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-batch',
  imports: [SharedModule],
  templateUrl: './create-batch.component.html',
  styleUrl: './create-batch.component.scss'
})
export class CreateBatchComponent {
  @Input() type: string = 'Create';
  @Input() batchData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  @Input() allAcademicYears: any[] = [];
  @Input() allCourses: any[] = [];
  @Input() allUsers: any[] = [];

  isSubmitted = false;
  btnLoading = false;
  loading = false;

  batchForm: FormGroup;
  academicYears: any[] = [];
  courses: any[] = [];
  users: any[] = [];

  statusOptions = ["Active", "Completed", "Canceled"];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: BatchService,
    private localStorage: LocalStorageService
  ) {
    this.batchForm = this.fb.group({
      batch_name: ['', Validators.required],
      academic_year_id: ['', Validators.required],
      user_id: ['', Validators.required],
      course_id: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      max_students: ['', [Validators.required, Validators.min(1)]],
      batch_status: ['Active', Validators.required],
      organization_id: [this.localStorage.getOrganizationId() || '']
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.batchData) {
      this.batchForm.patchValue({
        batch_name: this.batchData.batch_name,
        academic_year_id: this.batchData.academic_year_id,
        user_id: this.batchData.user_id,
        course_id: this.batchData.course_id,
        start_date: new Date(this.batchData.start_date),
        end_date: new Date(this.batchData.end_date),
        max_students: this.batchData.max_students,
        batch_status: this.batchData.batch_status
      });
    }
    // Load academic years, courses and users data
    this.loadAcademicYears();
    this.loadCourses();
    this.loadUsers();
  }

  loadAcademicYears() {
    // Implement loading academic years
  }

  loadCourses() {
    // Implement loading courses
  }

  loadUsers() {
    // Implement loading users
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.batchForm.valid) {
      this.btnLoading = true;
      const formData = this.batchForm.value;

      const payload = {
        ...formData,
        id : this.batchData?.id,
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId()
        
      };

      if (this.type === 'Update') {
        this.api.updateBatch(payload).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Batch updated successfully!'
            });
            this.reload.emit();
            this.handleCloseDialog();
          },
          error: (error) => {
            this.btnLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.error.message || 'Something went wrong!'
            });
          },
          complete: () => {
            this.btnLoading = false;
          }
        });
      } else {
        const payload = {
          ...formData,
          organization_id: this.localStorage.getOrganizationId(),
          campus_id: this.localStorage.getCampusId()
        };
        console.log(payload);
        this.api.createBatch(payload).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Batch created successfully!'
            });
            this.reload.emit();
            this.handleCloseDialog();
          },
          error: (error) => {
            this.btnLoading = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.error.message || 'Something went wrong!'
            });
          },
          complete: () => {
            this.btnLoading = false;
          }
        });
      }
    }
  }
}